import React from "react";
import { campaignApi, cancelSource, isCancelled } from "api/aiCampaigns";
import { describeError } from "../campaignUtils";
import { CampaignWorkspace } from "./CampaignWorkspace";

export class CampaignWorkspaceContainer extends React.Component {
  state = { analytics: null, updatedAt: null, loading: true, refreshing: false, retrying: null, stopping: null, restarting: null, error: "", notice: "", forbidden: false, latestOutcomes: null, outcomeRunId: null, outcomeError: "" };
  alive = false;
  componentDidMount() { this.alive = true; this.refresh(); }
  componentWillUnmount() { this.alive = false; clearTimeout(this.timer); if (this.source) this.source.cancel(); if (this.outcomeSource) this.outcomeSource.cancel(); }
  refreshOutcomes = async (analytics, force = false) => {
    const run = (analytics.generated_content || []).find(item => !item.sample_preview && item.campaign_id);
    if (!run) { if (this.alive) this.setState({ latestOutcomes: null, outcomeRunId: null, outcomeError: "" }); return; }
    if (!force && this.outcomeRunId === run.campaign_id && Date.now() - (this.outcomeFetchedAt || 0) < 300000) return;
    if (this.outcomeSource) this.outcomeSource.cancel();
    if (this.outcomeRunId !== run.campaign_id && this.alive) this.setState({ latestOutcomes: null, outcomeRunId: run.campaign_id, outcomeError: "" });
    this.outcomeSource = cancelSource(); this.outcomeRunId = run.campaign_id; this.outcomeFetchedAt = Date.now();
    try {
      const response = await campaignApi.getOutcomes(this.props.token, run.campaign_id, 7, this.outcomeSource.token);
      if (this.alive) this.setState({ latestOutcomes: response.data, outcomeRunId: run.campaign_id, outcomeError: "" });
    } catch (error) {
      if (this.alive && !isCancelled(error)) this.setState({ latestOutcomes: null, outcomeRunId: run.campaign_id, outcomeError: describeError(error).message });
    }
  };
  refresh = async () => {
    if (this.state.refreshing) return;
    if (this.source) this.source.cancel();
    this.source = cancelSource(); this.setState({ refreshing: true });
    try {
      const response = await campaignApi.getAnalytics(this.props.token, this.source.token);
      if (this.alive) {
        this.setState({ analytics: response.data, updatedAt: new Date(), error: "", forbidden: false });
        this.refreshOutcomes(response.data);
      }
    } catch (error) {
      if (this.alive && !isCancelled(error)) { const described = describeError(error); this.setState({ error: described.message, forbidden: described.forbidden }); }
    } finally {
      if (this.alive) { this.setState({ loading: false, refreshing: false }); this.timer = setTimeout(this.refresh, 30000); }
    }
  };
  retryFailure = async failure => {
    if (this.state.retrying) return;
    this.setState({ retrying: failure.campaign_id, error: "", notice: "" });
    try {
      const method = failure.retry_action === "retry_audience" ? campaignApi.retryAudience : campaignApi.retryGeneration;
      const response = await method(this.props.token, failure.campaign_id);
      if (this.alive) this.setState({ notice: response.message || "Retry queued from the failed step." }, this.refresh);
    } catch (error) {
      if (this.alive && !isCancelled(error)) this.setState({ error: describeError(error).message });
    } finally {
      if (this.alive) this.setState({ retrying: null });
    }
  };
  stopCampaign = async campaign => {
    if (this.state.stopping || !window.confirm(`Stop ${campaign.scenario && campaign.scenario.title ? campaign.scenario.title : "this notification set"}? Pending notifications will not be sent.`)) return;
    this.setState({ stopping: campaign.campaign_id, error: "", notice: "" });
    try {
      const response = await campaignApi.stop(this.props.token, campaign.campaign_id);
      if (this.alive) this.setState({ notice: response.message || "Notification set stopped." }, this.refresh);
    } catch (error) {
      if (this.alive && !isCancelled(error)) this.setState({ error: describeError(error).message });
    } finally {
      if (this.alive) this.setState({ stopping: null });
    }
  };
  restartCampaign = async campaign => {
    if (this.state.restarting) return;
    this.setState({ restarting: campaign.campaign_id, error: "", notice: "" });
    try {
      const response = await campaignApi.restart(this.props.token, campaign.campaign_id);
      if (this.alive) this.setState({ notice: response.message || "Notification set restarted from its saved step." }, this.refresh);
    } catch (error) {
      if (this.alive && !isCancelled(error)) this.setState({ error: describeError(error).message });
    } finally {
      if (this.alive) this.setState({ restarting: null });
    }
  };
  render() { return <CampaignWorkspace {...this.state} onRefresh={this.refresh} onRetryFailure={this.retryFailure} onStopCampaign={this.stopCampaign} onRestartCampaign={this.restartCampaign} onOpenCampaign={(id, list = "lead-list") => this.props.history.push(`${this.props.basePath}/${id}?list=${list}${list === "six-day" ? "&day=1" : ""}`)} />; }
}
